// extracted by mini-css-extract-plugin
module.exports = {"partnerModal":"PartnerModal_partnerModal__S69QS"};